import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const InvoiceTransactionsHistory = ({ isOpen, onRequestClose, invoiceId }) => {
    const [invoiceTransactions, setInvoiceTransactions] = useState([]);
    const [loader, setLoader] = useState(false);
    const token = JSON.parse(localStorage.getItem("data")).token;
  const navigate = useNavigate();

     const getData = async () => {
        setLoader(true);
        try {      
          const trans = await axios.get(`/api/invoiceTransactions/invoiceId=${invoiceId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
    
          setInvoiceTransactions(trans.data);
          setLoader(false);
        } catch (error) {
          setLoader(false);
          handleError(error);
        }
      };

      function handleError(error) {
          if (error.response) {
            if (error.response.status === 401) {
              navigate(`/signin`);
              toast.error("Your session has expired. Please login.");
            } else if (error.response.data && error.response.data.message) {
              toast.error(error.response.data.message);
            }  else if (error.response.data && error.response.data.code) {
              toast.error(error.response.data.code);
            }
             else {
              toast.error("An error occurred.");
            }
          } else if (error.message) {
            toast.error(error.message);
          } else {
            toast.error("An error occurred.");
          }
        }
    
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Invoice Transactions History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {loader && <div className="loading"></div>}

          <table className="table table-bordered">
                       <thead>
                         <tr>
                           <th>Payment Date</th>
                           <th>Mode Of Payment</th>
                           <th>Reference Number</th>
                           <th>Amount</th>
                           <th>Note</th>
                         </tr>
                       </thead>
                       <tbody>
                         {invoiceTransactions.length === 0 ? (
                           <tr>
                             <td colSpan="10" className="text-center">
                               No Data Available
                             </td>
                           </tr>
                         ) : (
                           invoiceTransactions.map((inv) => (
                             <tr key={inv.id}>
                               <td>{inv.paymentDate}</td>
                               <td>{inv.modeOfPayment?.paymentType}</td>
                               <td>{inv.referenceNumber}</td>
                               <td>₹{inv.amount}</td>
                               <td>{inv.notes}</td>

                             </tr>
                           ))
                         )}
                       </tbody>
                     </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onRequestClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InvoiceTransactionsHistory;
